<template>
  <div class="in container">

    <div id="QuoteInfo">

      <div class="cust-button" @click="toggle('quote_info_keys_show')">toggle inputs</div>
      <br>
      <quote-info-keys :quote="quote" v-show="quote_info_keys_show"></quote-info-keys>

      <div class="cust-button" @click="toggle('lease_rates_show')">toggle lease rates</div>
      <br>
      <lease-rates v-show="lease_rates_show"></lease-rates>

      <div class="cust-button" @click="toggle('calculation_tables_show')">toggle calculations table</div>
      <br>
      <calculation-tables :results="results" v-show="calculation_tables_show"></calculation-tables>
      <machine-lease-terms :new_costs="results.new_costs" :current_costs="results.current_costs"></machine-lease-terms>

    </div>
  </div>

</template>
<script>
  import QIK from './QuoteInfo/Keys.vue'
  import LeaseRates from './QuoteInfo/LeaseRates.vue'
  import CalculationTables from './QuoteInfo/CalculationTables.vue'
  import MachineLeaseTerms from './QuoteInfo/MachineLeaseTerms.vue'

  export default {
    name: "quote-info",
    props: ['quote', 'results'],
    components: {
      'quote-info-keys': QIK,
      'lease-rates': LeaseRates,
      'calculation-tables': CalculationTables,
      'machine-lease-terms': MachineLeaseTerms,
    },
    data() {
      return {
        calculation_tables_show: true,
        lease_rates_show: true,
        quote_info_keys_show: true,
      }
    },
    methods: {
      toggle(key) {
        this[key] = !this[key]
      }
    }
  }
</script>
<style lang="scss">
  #QuoteInfo {
    margin-bottom: 400px;
    table {
      width: 100%;
      td, th {
        border: 1px solid black;
        padding: 5px;
        font-size: 16px;
      }
    }

    b {
      font-weight: bold;
    }

    .cust-button {
      border: 1px solid black;
      display: inline-block;
      padding:3px;
      cursor:pointer;
      margin-bottom:5px;
      margin-top:20px;
    }

    @media screen and (max-width: 1023px) {
      margin-bottom: 100px;

      > div {
        overflow-x: scroll;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Debug/QuoteInfo.vue